module.exports = __webpack_public_path__ + "img/m3.09d0d8c2.png";